import React, {PureComponent} from 'react';
import styled from 'styled-components';

import * as api from '../lib/api';
import {withUser} from '../lib/user';
import Loading from './Loading';
import Error from './Error';
import FullScreenMessage from './FullScreenMessage';
import ActivityCard from './ActivityCard';
import Card from './Card';
import Nl2br from './Nl2br';

class AuditLog extends PureComponent {
  state = {
    loading: true,
    failed: false,
    logs: []
  };

  async componentDidMount() {
    const {tags, credentials} = this.props;

    try {
      const logs = await api.getAuditLogs(tags, credentials);
      this.setState({logs});
    }
    catch (e) {
      this.setState({failed: true});
    }
    finally {
      this.setState({loading: false});
    }
  }

  render() {
    const {children, formatValue = val => val} = this.props;
    const {loading, failed, logs} = this.state;

    if (loading) {
      return <Loading message="Loading history..." />;
    }

    if (failed) {
      return <Error message="Failed to load history" />;
    }

    if (logs.length < 1) {
      return <FullScreenMessage message="No changes have been made" />;
    }

    return (
      <Container>
        {logs.map(log => {
          const nextValues = log.next.map(next => formatValue(log, next)).filter(Boolean);
          const prevValues = log.previous.map(prev => formatValue(log, prev)).filter(Boolean);

          return (
            <div key={log.id}>
              <ActivityCard user={log.user} activity={children(log)} date={new Date(log.timestamp)}>
                {(log.comment || nextValues.length > 0 || prevValues.length > 0) && (
                  <Card.Content>
                    <DiffContainer>
                      {log.comment && (
                        <Comment>
                          <h4>Reason for Change</h4>
                          <Nl2br>{log.comment}</Nl2br>
                        </Comment>
                      )}
                      {nextValues.map((value, i) => (
                        <NextValue key={i}>{value}</NextValue>
                      ))}
                      {prevValues.map((value, i) => (
                        <PrevValue key={i}>{value}</PrevValue>
                      ))}
                    </DiffContainer>
                  </Card.Content>
                )}
              </ActivityCard>
            </div>
          );
        })}
      </Container>
    );
  }
}

const Container = styled.div`
  > div {
    margin-bottom: 1.5rem;

    :last-child {
      margin-bottom: 0;
    }
  }
`;

const DiffContainer = styled.ul`
  margin: 0;
  padding: 0;
`;

const NextValue = styled.li`
  padding: 0.5rem 1rem;
  display: block;
  background: #d4edda;
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
`;

const PrevValue = styled.li`
  padding: 0.5rem 1rem;
  display: block;
  background: #f8d7da;
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;

  :last-child {
    margin-bottom: 0;
  }
`;

const Comment = styled.div`
  background: #f5f5f8;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 0.5rem;

  h4 {
    margin: 0 0 0.25rem 0;
  }
`;

export default withUser(AuditLog);